import { render, staticRenderFns } from "./DocumentEditModeIndicator.vue?vue&type=template&id=9dded1c2&scoped=true&"
import script from "./DocumentEditModeIndicator.vue?vue&type=script&lang=ts&"
export * from "./DocumentEditModeIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEditModeIndicator.vue?vue&type=style&index=0&id=9dded1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dded1c2",
  null
  
)

export default component.exports